export class MPAInterceptedResponseMpaPolicies {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policies",
            "baseName": "policies",
            "type": "Array<ActionApprovalRule>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPAInterceptedResponseMpaPolicies.attributeTypeMap;
    }
    constructor() {
    }
}
